(function () {
  const SOURCE = 'cart-donation';
  const CONTAINER_SELECTOR = '[data-cart-donation]';
  const TOGGLE_SELECTOR = '[data-cart-donation-toggle]';
  const INFO_SELECTOR = '[data-cart-donation-info]';
  const ERROR_SELECTOR = '[data-cart-donation-error]';
  const LOADING_CLASS = 'cart-donation--loading';

  // The donation markup lives inside [target=cart-footer-contents], which is replaced
  // with innerHTML on every cart update, so elements are re-queried on each use and
  // the change listener is delegated from the document.
  function getContainer() {
    return document.querySelector(CONTAINER_SELECTOR);
  }

  function getSectionIds() {
    const cartItems = document.querySelector('cart-items');
    if (cartItems && typeof cartItems.getSectionsToRender === 'function') {
      return cartItems.getSectionsToRender().map((section) => section.section);
    }
    return ['cart-icon', 'main-cart'];
  }

  function setLoading(isLoading) {
    const container = getContainer();
    if (!container) return;

    container.classList.toggle(LOADING_CLASS, isLoading);
    const toggle = container.querySelector(TOGGLE_SELECTOR);
    if (toggle) toggle.disabled = isLoading;
  }

  function showError(message) {
    const container = getContainer();
    if (!container) return;

    const errorElement = container.querySelector(ERROR_SELECTOR);
    if (!errorElement) return;

    errorElement.textContent = message || '';
    errorElement.toggleAttribute('hidden', !message);
  }

  function renderCart(cart) {
    const cartItems = document.querySelector('cart-items');

    if (cartItems && cart && cart.sections && typeof publish === 'function') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: SOURCE, cartData: cart });
      return Promise.resolve();
    }

    return fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        ['cart-items', '[target=cart-footer-contents]', '[target=cart-count]'].forEach((selector) => {
          const target = document.querySelector(selector);
          const source = html.querySelector(selector);
          if (target && source) target.replaceWith(source);
        });

        document.dispatchEvent(new CustomEvent('cartFinnishUpdate', { bubbles: true }));
        if (window.jQuery) jQuery(document).trigger('cartFinnishUpdate');
      });
  }

  const INCIDENTAL_PROPERTY_KEYS = [
    '__gift_product_bb',
    '__free_product_bb',
    '__gift_product_bb_step1',
    '__gift_product_bb_step2',
  ];

  let donationSyncing = false;
  let donationSyncQueued = false;
  let lastStaleCartRefresh = 0;

  function isTruthyProperty(value) {
    return value === true || value === 'true';
  }

  function getDonationIds() {
    const toggle = document.querySelector(TOGGLE_SELECTOR);
    const container = getContainer();

    return {
      toggle,
      variantId: toggle && toggle.dataset.cartDonationVariantId,
      productId: container && container.dataset.cartDonationProductId,
    };
  }

  function isDonationCartItem(item, variantId, productId) {
    if (variantId && String(item.id) === String(variantId)) return true;
    if (productId && String(item.product_id) === String(productId)) return true;
    return false;
  }

  function isIncidentalCartItem(item, variantId, productId) {
    if (isDonationCartItem(item, variantId, productId)) return true;
    if (typeof sampleProductId !== 'undefined' && String(item.product_id) === String(sampleProductId)) return true;

    const properties = item.properties || {};
    return INCIDENTAL_PROPERTY_KEYS.some((key) => isTruthyProperty(properties[key]));
  }

  function isPurchasableLine(line, variantId) {
    if (line.hasAttribute('data-cart-donation-item')) return false;
    if (variantId && line.dataset.cartDonationVariantId === String(variantId)) return false;
    if (line.querySelector('[data-promo-product-remove], [data-bb-product], [data-free-product]')) return false;
    return true;
  }

  function domHasPurchasableProducts(variantId) {
    return Array.from(document.querySelectorAll('.cart-line-item')).some((line) => isPurchasableLine(line, variantId));
  }

  function uncheckDonationToggle() {
    document.querySelectorAll(TOGGLE_SELECTOR).forEach((toggle) => {
      toggle.checked = false;
    });
  }

  function cartJsUrl() {
    const root = (window.routes && routes.cart_url) || '/cart';
    return root + '.js';
  }

  // Gift, sample, and free-product scripts replace the cart markup after cartFinnishUpdate
  // without another event. Re-read the cart and clear the donation once nothing purchasable remains.
  function syncDonationWithCart() {
    const { toggle, variantId, productId } = getDonationIds();
    if (!toggle || !toggle.checked || !variantId) return Promise.resolve();
    if (domHasPurchasableProducts(variantId)) return Promise.resolve();

    uncheckDonationToggle();
    let removedDonation = false;

    return fetch(cartJsUrl(), { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then((response) => response.json())
      .then((cart) => {
        const items = (cart && cart.items) || [];
        const hasPurchasableProducts = items.some((item) => !isIncidentalCartItem(item, variantId, productId));
        const currentToggle = document.querySelector(TOGGLE_SELECTOR);

        if (hasPurchasableProducts) {
          const donationInCart = items.some((item) => isDonationCartItem(item, variantId, productId));
          if (currentToggle && donationInCart) currentToggle.checked = true;
          return;
        }

        uncheckDonationToggle();

        const updates = {};
        items.forEach((item) => {
          if (isDonationCartItem(item, variantId, productId)) updates[item.id] = 0;
        });
        if (!Object.keys(updates).length) {
          const now = Date.now();
          if (!document.querySelector('[data-cart-donation-item]') || now - lastStaleCartRefresh < 1000) return;
          lastStaleCartRefresh = now;
          return renderCart({});
        }

        const body = JSON.stringify({
          updates,
          sections: getSectionIds(),
          sections_url: window.location.pathname,
        });

        return fetch(routes.cart_update_url, { ...fetchConfig(), body })
          .then((response) => response.json())
          .then((updatedCart) => {
            if (updatedCart.status) {
              throw new Error(updatedCart.description || updatedCart.message);
            }
            removedDonation = true;
            return renderCart(updatedCart);
          });
      })
      .catch((error) => {
        console.error('Failed to remove donation from an empty cart', error);
        if (removedDonation) return;
        const currentToggle = document.querySelector(TOGGLE_SELECTOR);
        if (currentToggle) currentToggle.checked = true;
      });
  }

  function requestDonationSync() {
    if (donationSyncing) {
      donationSyncQueued = true;
      return;
    }

    donationSyncing = true;
    syncDonationWithCart().finally(() => {
      donationSyncing = false;
      if (!donationSyncQueued) return;
      donationSyncQueued = false;
      requestDonationSync();
    });
  }

  function watchCartDom() {
    if (typeof MutationObserver === 'undefined') return;

    const drawer = document.querySelector('cart-drawer');
    const cartItems = document.querySelector('cart-items');
    const root = drawer || (cartItems && cartItems.closest('.section-wrapper'));
    if (!root) return;

    let timer;
    const observer = new MutationObserver(() => {
      const toggle = document.querySelector(TOGGLE_SELECTOR);
      if (!toggle || !toggle.checked) return;
      window.clearTimeout(timer);
      timer = window.setTimeout(requestDonationSync, 50);
    });

    observer.observe(root, { childList: true, subtree: true });
  }

  function updateDonation(toggle) {
    const variantId = toggle.dataset.cartDonationVariantId;
    if (!variantId) return;

    const shouldDonate = toggle.checked;
    const updates = {};
    updates[variantId] = shouldDonate ? 1 : 0;

    showError('');
    setLoading(true);

    const body = JSON.stringify({
      updates,
      sections: getSectionIds(),
      sections_url: window.location.pathname,
    });

    fetch(routes.cart_update_url, { ...fetchConfig(), body })
      .then((response) => response.json())
      .then((cart) => {
        if (cart.status) {
          throw new Error(cart.description || cart.message);
        }
        return renderCart(cart);
      })
      .catch((error) => {
        console.error('Failed to update donation', error);
        // The markup was not re-rendered, so put the checkbox back in sync with the cart.
        const currentToggle = getContainer() && getContainer().querySelector(TOGGLE_SELECTOR);
        if (currentToggle) currentToggle.checked = !shouldDonate;
        showError((window.cartStrings && window.cartStrings.error) || error.message);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function setInfoOpen(button, isOpen) {
    button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    const descriptionId = button.getAttribute('aria-controls');
    const description = descriptionId && document.getElementById(descriptionId);
    if (description) description.hidden = !isOpen;
  }

  document.addEventListener('cartFinnishUpdate', requestDonationSync);
  document.addEventListener('cartUpdated', requestDonationSync);
  if (window.jQuery) {
    jQuery(document).on('cartUpdate cartFinnishUpdate cartFinnishUpdatePromo cartUpdated', requestDonationSync);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      watchCartDom();
      requestDonationSync();
    });
  } else {
    watchCartDom();
    requestDonationSync();
  }

  document.addEventListener('change', (event) => {
    const toggle = event.target.closest(TOGGLE_SELECTOR);
    if (!toggle) return;

    updateDonation(toggle);
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest(INFO_SELECTOR);
    const openButton = document.querySelector(`${INFO_SELECTOR}[aria-expanded="true"]`);

    if (button) {
      event.preventDefault();
      event.stopPropagation();
      setInfoOpen(button, button.getAttribute('aria-expanded') !== 'true');
      return;
    }

    if (openButton && !event.target.closest('#CartDonationDescription')) {
      setInfoOpen(openButton, false);
    }
  });
})();
